// extracted by mini-css-extract-plugin
export default {"content":"UsersAndContactsListDialogContent_content__FeGdJ","section":"UsersAndContactsListDialogContent_section__JAQf7"};